/**
 * Loại file nhập khẩu
 * pqkhanh 01.04.2024
 */
export default {
  Current: 1,
  Before: 2
};
